import { forwardRef, ReactNode } from 'react'

import { CButton } from '@coreui/react-pro'
import { CButtonProps } from '@coreui/react-pro/dist/components/button/CButton'
import classNames from 'classnames'

import 'scss/components/_button.scss'

interface Props extends Omit<CButtonProps, 'size'> {
  children: ReactNode
  color?: 'green' | 'light-green' | 'blue-gradient' | 'gray' | 'red'
  size?: 'xxSmall' | 'xSmall' | 'small' | 'medium' | 'large' | 'xLarge'
  className?: string
  startIcon?: ReactNode
  endIcon?: ReactNode
  isBold?: boolean
  hasUnderline?: boolean
  isHighlight?: boolean
  iconWithoutFixedSize?: boolean
}

const Button = forwardRef<HTMLButtonElement, Props>(
  (
    {
      children,
      color = 'green',
      size = 'medium',
      className = '',
      startIcon,
      endIcon,
      isBold = true,
      hasUnderline = false,
      isHighlight = false,
      iconWithoutFixedSize = false,
      ...rest
    },
    ref,
  ) => (
    <CButton
      {...rest}
      color={color}
      className={classNames(
        'btn-custom',
        `size-${size}`,
        {
          'fw-bold': isBold,
          underline: hasUnderline,
          'btn--highlight': isHighlight,
          'btn-custom--no-fixed-size-icon': iconWithoutFixedSize,
        },
        className,
      )}
      ref={ref}
    >
      {isHighlight ? (
        <span className="btn--highlight-content">
          {startIcon}
          {children}
          {endIcon}
        </span>
      ) : (
        <>
          {startIcon}
          {children}
          {endIcon}
        </>
      )}
    </CButton>
  ),
)

export default Button
